import type { ReactNode } from "react";
import { Button } from "@/design-system/components/react";

interface Props {
  children: ReactNode;
  actionLabel: string;
  onAction: () => void;
}

/**
 * A failure the reader must act on, in the AGENTS.md "Attention" style
 * (solid `border-strong` + `surface-2` lift). Load and save failures share it
 * so they look and recover the same way (ENG-229).
 */
export function StatusAlert({ children, actionLabel, onAction }: Props) {
  return (
    <div
      role="alert"
      className="my-2 flex flex-col items-start gap-2 rounded-[2px] border border-border-strong bg-surface-2 p-2.5 text-fg"
    >
      <p>{children}</p>
      <Button variant="outline" size="sm" className="h-7 px-2.5 text-xs" onClick={onAction}>
        {actionLabel}
      </Button>
    </div>
  );
}
